<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productList.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productList.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <form>
              <fieldset>
                <legend>{{ $t('productList.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </div>
        </div>
        <div class="row ts-mt-3">
          <div class="col-md-12 ts-flex ts-justify-end">
            <div class="ts-flex ts-space-x-3">
              <ts-button
                class="btn-block ts-mr-2 ts-w-40"
                outline
                color="success"
                @click.prevent="exportExcel"
                :waiting="exporting"
                ><i class="fas fa-file-excel"></i>
                {{ $t('excel') }}</ts-button
              >
              <ts-button
                color="primary"
                @click.prevent="preview"
                :waiting="waiting"
                ><i class="far fa-file-pdf"></i> {{ $t('preview') }}</ts-button
              >
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'productList',
  data() {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      src: '',
    }
  },
  methods: {
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/inventory/productList')
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/inventory/productListExcel')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
  },
}
</script>
